<div class="topbar-user-block">

  <!-- User pill: avatar + name + company type -->
  <div class="user-pill">
    <div class="user-avatar">{{ userInitials }}</div>
    <div class="user-meta">
      <span class="user-name">{{ userName }}</span>
      <span class="user-company">{{ companyTypeDescription }}</span>
    </div>
  </div>

  <!-- Sair -->
  <button class="sair-btn" (click)="logout()">Sair</button>

</div>
